import quantize from "quantize";
import { findImage } from "../schedule-history/image-registry";

export function baseImagePalette(base: string | undefined) {
  const image = base ? findImage(base) : undefined;
  if (!image) return [];

  // Sample a small image, preserving its proportions and ignoring transparent margins.
  const canvas = document.createElement("canvas");
  const scale = 128 / Math.max(image.naturalWidth, image.naturalHeight);
  canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (!context) return [];
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  const { data } = context.getImageData(0, 0, canvas.width, canvas.height);
  const pixels: quantize.RgbPixel[] = [];
  for (let index = 0; index < data.length; index += 4) {
    if (data[index + 3]! < 128) continue;
    pixels.push([data[index]!, data[index + 1]!, data[index + 2]!]);
  }
  canvas.width = 0;
  canvas.height = 0;
  if (!pixels.length) return [];

  const colors = quantize(pixels, 6);
  if (!colors) return [];
  const hexColors = colors.palette().map(rgb =>
    "#" + rgb.map(channel => channel.toString(16).padStart(2, "0")).join(""));
  return [...new Set(hexColors)].slice(0, 6);
}
